import Link from 'next/link';
import PropTypes from 'prop-types';
import Spinner from './Spinner';
import { UilSearch, UilEllipsisV } from '@iconscout/react-unicons';

const Button = (props) => {
  const {
    content = 'label-only',
    variant = 'primary',
    children = 'Button small',
    loading,
    theme = 'blue-hedgehog',
    type = 'button',
    link = '/',
    action,
    className = '',
    icon,
    hover,
    disabled,
    isBlock,
    isLarge,
  } = props;

  return (
    <>
      {type === 'link' ? (
        <Link href={link}>
          <button
            className={`${isBlock && 'w-full flex justify-center items-center'} ${isLarge && 'py-4'} ${variant} ${className} ${
              loading && 'cursor-not-allowed'
            } ${
              !loading
                ? variant === 'outlined'
                  ? theme + '-outlined'
                  : variant === 'secondary'
                  ? theme + '-secondary'
                  : variant === 'transparent'
                  ? theme + '-transparent'
                  : variant === 'subtle'
                  ? theme + '-subtle'
                  : theme
                : variant === 'outlined'
                ? theme + '-outlined-loading'
                : variant === 'secondary'
                ? theme + '-secondary-loading'
                : variant === 'subtle'
                ? theme + '-subtle-loading'
                : theme + '-loading'
            }`}
          >
            {content === 'icon-only' ? (
              icon || <UilEllipsisV size="20" />
            ) : content === 'icon-infront' ? (
              <div className="flex items-center">
                {icon || <UilSearch size="18" />} <span className="ml-2">{children}</span>
              </div>
            ) : content === 'icon-behind' ? (
              <div className="flex items-center">
                <span className="mr-2">{children}</span> {icon || <UilSearch size="18" />}
              </div>
            ) : (
              children
            )}
          </button>
        </Link>
      ) : (
        <button
          onMouseOver={hover}
          onMouseLeave={hover}
          onClick={action}
          type={type}
          disabled={loading || disabled ? true : false}
          className={`${disabled ? 'opacity-50' : ''} ${isLarge && 'py-4'} ${
            isBlock && 'w-full flex justify-center items-center'
          } ${variant} ${className} ${loading || (disabled && 'cursor-not-allowed')} ${
            !loading
              ? variant === 'outlined'
                ? theme + '-outlined'
                : variant === 'secondary'
                ? theme + '-secondary'
                : variant === 'transparent'
                ? theme + '-transparent'
                : variant === 'subtle'
                ? theme + '-subtle'
                : theme
              : variant === 'outlined'
              ? theme + '-outlined-loading'
              : variant === 'secondary'
              ? theme + '-secondary-loading'
              : variant === 'subtle'
              ? theme + '-subtle-loading'
              : variant === '-transparent'
              ? theme + '-transparent-loading'
              : theme + '-loading'
          } `}
        >
          {loading ? (
            <>
              {content === 'icon-only' ? (
                <Spinner
                  color={
                    variant === 'outlined' || variant === 'secondary' || variant === 'transparent' || variant === 'subtle'
                      ? '#859DFF'
                      : '#FFFFFF'
                  }
                />
              ) : content === 'icon-infront' ? (
                <div className="flex justify-center items-center">
                  <Spinner
                    color={
                      variant === 'outlined' || variant === 'secondary' || variant === 'transparent' || variant === 'subtle'
                        ? '#859DFF'
                        : '#FFFFFF'
                    }
                  />
                  <span className="ml-1">{children}</span>
                </div>
              ) : (
                <div className="flex justify-center items-center">
                  <span className="mr-1">{children}</span>
                  <Spinner
                    className="mr-2"
                    color={
                      variant === 'outlined' || variant === 'secondary' || variant === 'transparent' || variant === 'subtle'
                        ? '#859DFF'
                        : '#FFFFFF'
                    }
                  />
                </div>
              )}
            </>
          ) : content === 'icon-only' ? (
            icon || <UilEllipsisV size="20" />
          ) : content === 'icon-infront' ? (
            <div className="flex items-center">
              {icon || <UilSearch size="18" />} <span className="ml-2">{children}</span>
            </div>
          ) : content === 'icon-behind' ? (
            <div className="flex items-center">
              <span className="mr-2">{children}</span> {icon || <UilSearch size="18" />}
            </div>
          ) : (
            children
          )}
        </button>
      )}
    </>
  );
};

Button.propTypes = {
  variant: PropTypes.string,
  theme: PropTypes.string,
  loading: PropTypes.bool,
  action: PropTypes.func,
  disabled: PropTypes.bool,
  isBlock: PropTypes.bool,
  isLarge: PropTypes.bool,
  className: PropTypes.string,
};

export default Button;
